import LayoutCheckbox from 'components/forms/layoutCheckbox';
import LayoutDatePicker from 'components/forms/layoutDatePicker';
import LayoutInput from 'components/forms/layoutInput';
import LayoutSelect from 'components/forms/layoutSelect';
import PropTypes from 'prop-types';
import React from 'react';
import SuggestedProductsModal from './SuggestedProducts';
import ToolTip, {tooltipPositions} from 'components/ToolTip';
// import TruBluePreferences from './TruBluePreferences';
import hopscotch from 'hopscotch';
import session from 'services/sessionService';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {balanceColumns} from 'helpers/fieldHelpers';
import {dealerAdminTourFormat, countries, temperatureFormat} from 'helpers/constants';
import {getSuggestedProducts} from 'api/suggestedProduct';
import {suggestedProductsEnabled} from 'features';
import NewPlasterText from './NewPlasterText';
import throttle from 'lodash/throttle';
import PrintOutOptions from './PrintOutOptions';
import {getNaturalChemistryProducts} from 'helpers/suggestedProductList';

class PreferenceOptions extends React.Component {
  static propTypes = {
    dataChanged: PropTypes.func.isRequired,
    dealer: PropTypes.object.isRequired,
    edit: PropTypes.bool.isRequired,
    group: PropTypes.any.isRequired,
    ncProductsIntegration: PropTypes.bool,
    products: PropTypes.array.isRequired,
    suggestedProducts: PropTypes.array,
    updateSaveEnabled: PropTypes.func.isRequired,
    updateSuggestedProducts: PropTypes.func,
    intl: intlShape.isRequired,
  };

  state = {
    openSuggestedProductsModal: false,
  };

  componentDidMount() {
    if (hopscotch.getState() === 'dealerAdmin:13') {
      hopscotch.startTour(dealerAdminTourFormat(this.props.intl.formatMessage), 13);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.getNextAnalysis(nextProps, true);
    this.getSeasonUsage(nextProps, true);
  }

  getProductSuggestions = () => {
    const {dealer, ncProductsIntegration} = this.props;

    getSuggestedProducts()
      .then(result => {
        if (result.length) {
          if (!ncProductsIntegration) {
            let {country} = dealer;
            const ncProducts = getNaturalChemistryProducts(country || countries.US).map(ncp => ncp.id);

            result = result.filter(p => !ncProducts.includes(p.product));
          }
          this.props.updateSuggestedProducts(result, true);
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  getAnalysisReport = (props = this.props) => {
    let dealer = props.dealer;
    let {formatMessage} = this.props.intl;

    let defaultPreview =
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.default.preview'})}
        dataKey="defaultPreview"
        key="defaultPreview"
        data-event-category="User"
        data-event-action="sel-ana-def-prev"
        value={dealer.defaultPreview}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={[formatMessage({id: 'preferences.analysis.product.recommendations'}), formatMessage({id: 'preferences.analysis.analysis.results'})]}
        keys={[0, 1]}
      />

    ;

    let newPlaster = <NewPlasterText plasterText={props.dealer.newPlasterText} dataChanged={throttle(props.dataChanged, 250)} editMode={props.edit} />;

    return (
      <div>
        <p style={{marginBottom: 30}}>
          <FormattedMessage id="preferences.analysis.choose.page" />
        </p>
        <div className="row">
          <div className="col-xs-4">{defaultPreview}</div>
          <div className="col-xs-8">{newPlaster}</div>
        </div>
      </div>
    );
  };

  allowSuggestedProducts = () => {
    let {suggestedProducts, updateSuggestedProducts} = this.props;

    if (suggestedProducts) {
      updateSuggestedProducts(null);
    } else {
      updateSuggestedProducts([]);
    }
  };

  switchPrintOutOption = e => {
    if (this.props.dataChanged) {
      this.props.dataChanged({key: 'keyParametersRanges', value: parseInt(e.value)});
    }
  };

  getOverrideOxidizerOptions = (dealerCountry) => {
    // Basic Shock is for US only
    if (dealerCountry === 'US'){
      return {keys: [17, 29, 46, 225, 187], options: ['BurnOut 73', 'BurnOut 3', 'Chlorinating Liquid', 'Basic Shock', 'All Products']};
    };
      return {keys: [17, 29, 46, 187], options: ['BurnOut 73', 'BurnOut 3', 'Chlorinating Liquid', 'All Products']};
  };

  getCalculationParameters = (props = this.props) => {
    let all = [];
    let dealer = props.dealer;
    let {formatMessage} = this.props.intl;
    // Used in recommendations as InOzs

    const overrideOxidizerOptions = this.getOverrideOxidizerOptions(dealer.country);

    all.push(
      <LayoutCheckbox
        label={formatMessage({id: 'preferences.analysis.products.ounces'})}
        dataKey="displaySpaProductsOunces"
        key="displaySpaProductsOunces"
        data-event-category="User"
        data-event-action="check-ana-spa-oz"
        value={dealer.displaySpaProductsOunces}
        editMode={props.edit}
        dataChanged={props.dataChanged}
      />
    );

    // Used to override oxidizers after recommendations are run. After refactor should probably be merged into recommendations code instead of after the fact
    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.override.oxidizer'})}
        dataKey="overrideOxidizer"
        key="overrideOxidizer"
        value={dealer.overrideOxidizer}
        data-event-category="User"
        data-event-action="sel-ana-oxi-override"
        editMode={props.edit}
        dataChanged={props.dataChanged}
        keys={overrideOxidizerOptions.keys}
        options={overrideOxidizerOptions.options}
      />
    );

    return balanceColumns(all, 3);
  };

  getNextAnalysis = (props = this.props) => {
    let all = [];
    let dealer = props.dealer;
    let {formatMessage} = this.props.intl;

    all.push(
      <LayoutInput
        label={formatMessage({id: 'general.pool'})}
        dataKey="nextPoolAnalysis"
        key="nextPoolAnalysis"
        value={dealer.nextPoolAnalysis}
        editMode={props.edit}
        unit={formatMessage({id: 'general.days'})}
        dataChanged={props.dataChanged}
        group={props.group}
        validate={val => !val || val === 0 || val >= 7 && val <= 30}
        validateMessage={<FormattedMessage id="preferences.analysis.pool.validation" />}
      />
    );

    all.push(
      <LayoutInput
        label={formatMessage({id: 'general.spa'})}
        dataKey="nextSpaAnalysis"
        key="nextSpaAnalysis"
        value={dealer.nextSpaAnalysis}
        editMode={props.edit}
        unit={formatMessage({id: 'general.days'})}
        dataChanged={props.dataChanged}
        group={props.group}
        validate={val => !val || val === 0 || val >= 7 && val <= 90}
        validateMessage={<FormattedMessage id="preferences.analysis.spa.validation" />}
      />
    );

    all.push(
      <LayoutInput
        label={formatMessage({id: 'general.algae'})}
        dataKey="algaeFollowUp"
        key="algaeFollowUp"
        value={dealer.algaeFollowUp}
        editMode={props.edit}
        unit={formatMessage({id: 'general.days'})}
        dataChanged={props.dataChanged}
        group={props.group}
        validate={val => !val || val === 0 || val >= 0 && val <= 7}
        validateMessage={<FormattedMessage id="preferences.analysis.algae.validation" />}
      />
    );

    all.push(
      <LayoutInput
        label={formatMessage({id: 'general.chlorine.demand'})}
        dataKey="cdFollowUp"
        key="cdFollowUp"
        value={dealer.cdFollowUp}
        editMode={props.edit}
        unit={formatMessage({id: 'general.days'})}
        dataChanged={props.dataChanged}
        group={props.group}
        validate={val => !val || val === 0 || val >= 0 && val <= 7}
        validateMessage={<FormattedMessage id="preferences.analysis.chlorine.validation" />}
      />
    );

    all.push(
      <LayoutInput
        label={formatMessage({id: 'general.water.clarity'})}
        dataKey="clarityFollowUp"
        key="clarityFollowUp"
        value={dealer.clarityFollowUp}
        editMode={props.edit}
        unit={formatMessage({id: 'general.days'})}
        dataChanged={props.dataChanged}
        group={props.group}
        validate={val => !val || val === 0 || val >= 0 && val <= 7}
        validateMessage={<FormattedMessage id="preferences.analysis.clarity.validation" />}
      />
    );

    all.push(
      <LayoutInput
        label={formatMessage({id: 'general.surface.problems'})}
        dataKey="surfaceProblemsFollowUp"
        key="surfaceProblemsFollowUp"
        value={dealer.surfaceProblemsFollowUp}
        editMode={props.edit}
        unit={formatMessage({id: 'general.days'})}
        dataChanged={props.dataChanged}
        group={props.group}
        validate={val => !val || val === 0 || val >= 0 && val <= 7}
        validateMessage={<FormattedMessage id="preferences.analysis.surface.validation" />}
      />
    );

    return balanceColumns(all, 3);
  };

  getProductOptions = (props = this.props) => {
    let all = [];
    let {dealer, ncProductsIntegration} = props;
    let {formatMessage} = this.props.intl;
    let {openSuggestedProductsModal} = this.state;

    // Used in recommendations code as pHLowBorateON
    // No good way to tell which branch this is for hence cannot figure out whether optimizer plus or maximizer

    // Used in recommendations code as NeedOxysheenFirstTimeMaintenance
    all.push(
      <LayoutCheckbox
        label={formatMessage({id: 'preferences.analysis.oxysheen.maintenance'})}
        dataKey="oxysheenMaintClarifierDemand"
        key="oxysheenMaintClarifierDemand"
        data-event-category="User"
        data-event-action="check-ana-oxysheen"
        value={dealer.oxysheenMaintClarifierDemand}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        condition={dealer.country === countries.US}
      />
    );

    // Used to update the clarifier field on analysis page
    all.push(
      <LayoutCheckbox
        label={formatMessage({id: 'preferences.analysis.hazy.water'})}
        dataKey="defaultProductHazyWater"
        key="defaultProductHazyWater"
        data-event-category="User"
        data-event-action="check-ana-def-hazy"
        value={dealer.defaultProductHazyWater}
        editMode={props.edit}
        dataChanged={props.dataChanged}
      />
    );

    // Used in recommendations as UsingSaltScapes
    all.push(
      <LayoutCheckbox
        label={formatMessage({id: 'preferences.analysis.saltScapes'})}
        dataKey="saltScapes"
        key="saltScapes"
        value={dealer.saltScapes}
        editMode={props.edit}
        data-event-category="User"
        data-event-action="check-ana-saltscapes"
        dataChanged={props.dataChanged}
      />
    );

    all.push(
      <LayoutCheckbox
        label={formatMessage({id: 'preferences.analysis.closing.complete'})}
        dataKey="poolClosingComplete"
        key="poolClosingComplete"
        value={dealer.poolClosingComplete}
        editMode={props.edit}
        data-event-category="User"
        data-event-action="check-ana-pool-closing-complete"
        dataChanged={props.dataChanged}
      />
    );

    // [ALEX-2904] - Removed select to avoid duplicated dropdowns because of the changes that enabled
    //               the default products section regardless of the NC Products Integration

    // if(!ncProductsIntegration) {
    //   all.push(
    //     <LayoutSelect
    //     label={formatMessage({id: 'preferences.analysis.default.hazy'})}
    //     dataKey="defaultHazyProduct"
    //     key="defaultHazyProduct"
    //     data-event-category="User"
    //     data-event-action="sel-ana-def-hazy"
    //     value={dealer.defaultHazyProduct}
    //     editMode={props.edit}
    //     dataChanged={props.dataChanged}
    //     options={['Natural Clarifier', 'Polysheen Blue']}
    //     keys={[60, 62]}
    //   />
    // );
    // }
    const onOpenSuggestedProductsModal = e => {
      e.stopPropagation();
      this.setState({openSuggestedProductsModal: true});
    };

    const suggestedProductsComponent =
      <div className="container-fluid suggested-products-check">
        <div className="row">
          <div className="col-sm-8">
            <LayoutCheckbox
              label={formatMessage({id: 'preferences.suggested.products'})}
              dataKey="suggestedProductsCheckbox"
              key="suggestedProductsCheckbox"
              data-event-category="User"
              value={!!props.suggestedProducts}
              editMode={props.edit}
              dataChanged={this.allowSuggestedProducts}
            />
          </div>
          {props.edit && props.suggestedProducts ?
            <div className="col-sm-4">
              <a onClick={onOpenSuggestedProductsModal}>
                <FormattedMessage id="general.view" />
              </a>
            </div> :
           null}
        </div>
        {openSuggestedProductsModal ?
          <SuggestedProductsModal
            dealer={dealer}
            closeModal={() => this.setState({openSuggestedProductsModal: false})}
            ncProductsIntegration={ncProductsIntegration}
            products={props.suggestedProducts}
            savedProducts={products => props.updateSuggestedProducts(products, true)}
          /> :
         null}
      </div>

    ;

    if (suggestedProductsEnabled) {
      all.push(suggestedProductsComponent);
    }

    return balanceColumns(all, 3);
  };

  getSeasonUsage = (props = this.props) => {
    let all = [];
    let dealer = props.dealer;
    let {formatMessage} = this.props.intl;

    all.push(
      <LayoutDatePicker
        label={formatMessage({id: 'preferences.analysis.opening.date'})}
        key="seasonOpen"
        dataKey="seasonOpen"
        value={dealer.seasonOpen}
        editMode={props.edit}
        onChange={props.dataChanged}
        popperPlacement="top"
        dateFormat="MMMM D"
      />
    );

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.margin.weeks'})}
        dataKey="seasonOpenMargin"
        key="seasonOpenMargin"
        value={dealer.seasonOpenMargin}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={['1', '2', '3']}
      />
    );

    all.push(
      <LayoutDatePicker
        label={formatMessage({id: 'preferences.analysis.close.date'})}
        key="seasonClose"
        dataKey="seasonClose"
        popperPlacement="top"
        value={dealer.seasonClose}
        editMode={props.edit}
        onChange={props.dataChanged}
        dateFormat="MMMM D"
      />
    );

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.margin.weeks'})}
        dataKey="seasonCloseMargin"
        key="seasonCloseMargin"
        value={dealer.seasonCloseMargin}
        dataChanged={props.dataChanged}
        editMode={props.edit}
        options={['1', '2', '3']}
      />
    );

    return balanceColumns(all, 2);
  };

  getWaterBalance = (props = this.props) => {
    let all = [];
    let dealer = props.dealer;
    let {formatMessage} = this.props.intl;
    const nonFoamingAlgicideOptions = {
      US: {
        keys: [28, 40, 33],
        labels: ['Algae Complete®', 'Banish®', 'Algae All 60®'],
      },
      CA: {
        keys: [40, 167],
        labels: ['Banish®', 'Polygard'],
      },
    };

    // Used in the old code for recommendations as BalHardnessTo
    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.balance.ch'})}
        dataKey="balanceCHTo"
        key="balanceCHTo"
        value={dealer.balanceCHTo}
        dataChanged={props.dataChanged}
        data-event-category="User"
        data-event-action="select-ana-balance-ch"
        editMode={props.edit}
        keys={['Use LSI', '200', '250', '300', '350']}
        options={[formatMessage({id: 'general.balanceCHTo.lsi'}), '200', '250', '300', '350']}
      />
    );
    // In recommendations as ISTATarget
    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.balance.target'})}
        dataKey="inSeasonTABalanceTarget"
        key="inSeasonTABalanceTarget"
        data-event-category="User"
        data-event-action="select-ana-balance-target"
        value={dealer.inSeasonTABalanceTarget}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={['135', '150']}
      />
    );
    // Used to pick units for smart shock product

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.smart.shock'})}
        dataKey="smartShockMinSize"
        key="smartShockMinSize"
        value={dealer.smartShockMinSize}
        data-event-category="User"
        data-event-action="select-ana-shockmin"
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={['1 lb bags', '2 lb bottles']}
        keys={['1', '2']}
        condition={dealer.country === countries.US}
      />
    );

    //Turns off the pop up message for high CYA for bromine pools. This is a drain message that appears if the CYA > 30 ppm for bromine. There is an option on the pop up message to not display this message again. If that checkbox is selected in the pop up, the checkbox here in Analysis Options is checked as well.
    all.push(
      <LayoutCheckbox
        label={formatMessage({id: 'preferences.analysis.disabledrain.bromine'})}
        dataKey="disableDrainPopBromide"
        key="disableDrainPopBromide"
        value={dealer.disableDrainPopBromide}
        data-event-category="User"
        data-event-action="check-ana-disable-drain-bromine"
        editMode={props.edit}
        dataChanged={props.dataChanged}
        condition={dealer.country === countries.CA}
      />
    );

    // If water features like jetted returns then on customer systems page the default prev algicide should change to this non-foaming algicide
    all.push(
      <LayoutSelect
        className="non-foaming-algicide"
        label={formatMessage({id: 'preferences.analysis.nonfoaming.algicide'})}
        dataKey="nonFoamingAlgicide"
        key="nonFoamingAlgicide"
        value={dealer.nonFoamingAlgicide}
        data-event-category="User"
        data-event-action="select-ana-foam-alg"
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={nonFoamingAlgicideOptions[dealer.country || countries.US].labels}
        keys={nonFoamingAlgicideOptions[dealer.country || countries.US].keys}
      />
    );

    // Used in recommendations code as NoTraceMetals
    all.push(
      <LayoutCheckbox
        label={formatMessage({id: 'preferences.analysis.treat.trace'})}
        dataKey="doNotTreatTraceMetals"
        key="doNotTreatTraceMetals"
        value={dealer.doNotTreatTraceMetals}
        data-event-category="User"
        data-event-action="check-ana-trace"
        editMode={props.edit}
        dataChanged={props.dataChanged}
      />
    );

    return balanceColumns(all, 3);
  };

  spaCleanDrainOptions = (props = this.props) => {
    let dealer = props.dealer;
    let all = [];
    let {formatMessage} = this.props.intl;

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.number.months'})}
        dataKey="spaDrainFrequency"
        key="spaDrainFrequency"
        value={dealer.spaDrainFrequency}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']}
      />
    );

    return balanceColumns(all, 3);
  };

  getDefaultProducts = (props = this.props) => {
    let all = [];
    let {dealer, ncProductsIntegration} = props;
    let {formatMessage} = this.props.intl;

    const defaultOpeningProduct = {
      US: {
        keys: [223, 205],
        labels: ['Pool Complete® 911', 'Pool First Aid™'],
      },
      CA: {
        keys: [223, 205],
        labels: ['Pool Complete® 911', 'Pool First Aid™'],
      },
    };

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.default.opening'})}
        dataKey="defaultOpening"
        key="defaultOpening"
        data-event-category="User"
        data-event-action="sel-ana-def-opening"
        value={dealer.defaultOpening}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={defaultOpeningProduct[dealer.country || countries.US].labels}
        keys={defaultOpeningProduct[dealer.country || countries.US].keys}
      />
    );

    all.push(
      <LayoutSelect
          label={formatMessage({id: 'preferences.analysis.default.cover-maintenance'})}
          dataKey="defaultCoverMaintenance"
          key="defaultCoverMaintenance"
          data-event-category="User"
          data-event-action="sel-ana-def-cover-maintenance"
          value={dealer.defaultCoverMaintenance}
          editMode={props.edit}
          dataChanged={props.dataChanged}
          condition={dealer.country === countries.US}
          options={['Stow-Away', 'Spray-On Cleaner']}
          keys={[136, 206]}
        />
    );

    let defaultEnzymeProduct = {
      US: {
        keys: [223, 118, 207],
        labels: ['Pool Complete® 911','Natural Result', 'Pool Perfect® MAX'],
      },
      CA: {
        keys: [223, 118, 207],
        labels: ['Pool Complete® 911', 'Natural Result', 'Pool Perfect™ MAX'],
      },
    };

    defaultEnzymeProduct = defaultEnzymeProduct[dealer.country || countries.US];

    if(!ncProductsIntegration) {
      // Remove Pool Perfect® MAX
      defaultEnzymeProduct.keys.pop();
      defaultEnzymeProduct.labels.pop();
    }


    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.default.enzyme'})}
        dataKey="defaultEnzyme"
        key="defaultEnzyme"
        data-event-category="User"
        data-event-action="sel-ana-def-enzyme"
        value={dealer.defaultEnzyme}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={defaultEnzymeProduct.labels}
        keys={defaultEnzymeProduct.keys}
      />
    );

    let defaultPhosphateProduct = {
      US: {
        keys: [221, 208],
        labels: ['Zero Phos™', 'PHOSfree® MAX'],
      },
      CA: {
        keys: [221, 208],
        labels: ['Zero Phos™', 'PHOSfree® MAX'],
      },
    };

    defaultPhosphateProduct = defaultPhosphateProduct[dealer.country || countries.US];

    if(!ncProductsIntegration) {
      // Remove PHOSfree® MAX
      defaultPhosphateProduct.keys.pop();
      defaultPhosphateProduct.labels.pop();
    }

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.default.phosphate'})}
        dataKey="defaultPhosphate"
        key="defaultPhosphate"
        data-event-category="User"
        data-event-action="sel-ana-def-phosphate"
        value={dealer.defaultPhosphate}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={defaultPhosphateProduct.labels}
        keys={defaultPhosphateProduct.keys}
      />
    );

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.default.stain-remover'})}
        dataKey="defaultStainRemover"
        key="defaultStainRemover"
        data-event-category="User"
        data-event-action="sel-ana-def-stain-remover"
        value={dealer.defaultStainRemover}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        condition={dealer.country === countries.US}
        options={['Erase Iron Stain Remover', 'STAINFree Extra Strength']}
        keys={[109, 209]}
      />
    );

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.default.metals'})}
        dataKey="defaultMetals"
        key="defaultMetals"
        data-event-category="User"
        data-event-action="sel-ana-def-metals"
        value={dealer.defaultMetals}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={['Pool Magnet Plus', 'METALFree']}
        keys={[6, 210]}
      />
    );

    let defaultSwampyProduct = {
      US: {
        labels: ['Pool Complete® 911', 'Pool Tonic', 'Power Floc', 'Pool First Aid™'],
        keys: [223, 63, 123, 205],
      },
      CA: {
        labels: ['Pool Complete® 911', 'Pool First Aid™'],
        keys: [223, 205],
      },
    };

    defaultSwampyProduct = defaultSwampyProduct[dealer.country || countries.US];

    if(!ncProductsIntegration) {
      //Remove Pool First Aid™
      defaultSwampyProduct.keys.pop();
      defaultSwampyProduct.labels.pop();
    }

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.default.swampy-water'})}
        dataKey="defaultSwampyWater"
        key="defaultSwampyWater"
        data-event-category="User"
        data-event-action="sel-ana-def-swampy"
        value={dealer.defaultSwampyWater}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={defaultSwampyProduct.labels}
        keys={defaultSwampyProduct.keys}
      />
    );

    let defaultHazyProduct = {
      US: {
        labels: ['Pool Complete® 911', 'Natural Clarifier', 'Polysheen Blue', 'Pool First Aid™'],
        keys: [223, 60, 62, 205],
      },
      CA: {
        labels: ['Pool Complete® 911', 'Natural Clarifier', 'Polysheen Blue', 'Pool First Aid™'],
        keys: [223, 60, 62, 205],
      },
    };

    defaultHazyProduct = defaultHazyProduct[dealer.country || countries.US];

    if(!ncProductsIntegration) {
      // Remove Pool First Aid™
      defaultHazyProduct.keys.pop();
      defaultHazyProduct.labels.pop();
    }

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.default.hazy-water'})}
        dataKey="defaultHazyProduct"
        key="defaultHazyProduct"
        data-event-category="User"
        data-event-action="sel-ana-def-hazy"
        value={dealer.defaultHazyProduct}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={defaultHazyProduct.labels}
        keys={defaultHazyProduct.keys}
      />
    );

    all.push(
      <LayoutCheckbox
        label={formatMessage({id: 'preferences.analysis.default.cya-remover'})}
        dataKey="cyaRemover"
        key="cyaRemover"
        value={dealer.cyaRemover}
        editMode={props.edit}
        dataChanged={props.dataChanged}
      />
    );

    if(dealer.country === countries.US) {
      all.push(<LayoutCheckbox
        label={formatMessage({id: 'preferences.analysis.default.saltwater-magic-monthly'})}
        dataKey="saltwaterMagicMonthly"
        key="saltwaterMagicMonthly"
        value={dealer.saltwaterMagicMonthly}
        editMode={props.edit}
        dataChanged={props.dataChanged}
      />);
    }else{
      all.push(<div />);
    }

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.default.spa-enzyme'})}
        dataKey="deafultSpaEnzyme"
        key="deafultSpaEnzyme"
        data-event-category="User"
        data-event-action="sel-ana-def-spa-enzyme"
        value={dealer.deafultSpaEnzyme}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={['Natural Spa Enzyme', dealer.country === countries.US ? 'Spa Perfect®' : 'Spa Perfect™']}
        keys={[16, 211]}
      />
    );

    const spaLineCleanerLabels = dealer.country === countries.US ? ['SpaGuard System Flush', 'Spa Purge'] : ['Swirl Away', 'Spa Purge'];
    const spaLineCleanerKeys = dealer.country === countries.US ?  [25, 212] : [184 , 212];

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.default.spa-line-cleaner'})}
        dataKey="defaultSpaLineCleaner"
        key="defaultSpaLineCleaner"
        data-event-category="User"
        data-event-action="sel-ana-def-spa-purge"
        value={dealer.defaultSpaLineCleaner}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={spaLineCleanerLabels}
        keys={spaLineCleanerKeys}
      />
    );

    all.push(
      <LayoutCheckbox
        label={formatMessage({id: 'preferences.analysis.default.balance-complete'})}
        dataKey="balanceComplete"
        key="balanceComplete"
        value={dealer.balanceComplete}
        condition={dealer.country === 'US'}
        editMode={props.edit}
        dataChanged={props.dataChanged}
      />
    );

    const poolScalePreventionLabels = ['Scale Inhibitor', 'None'];
    const poolScalePreventionKeys = [8, 61]; // 61 is None under Warden IDs in Rules repo

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.default.pool-scale-prevention'})}
        dataKey="poolScalePrevention"
        key="poolScalePrevention"
        data-event-category="User"
        data-event-action="sel-ana-def-pool-sca-prev"
        value={dealer.poolScalePrevention}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={poolScalePreventionLabels}
        keys={poolScalePreventionKeys}
        tooltip={dealer.country === 'US' ? 
          formatMessage({id: 'preferences.analysis.default.pool-scale-prevention-tooltip-us'}) : 
          formatMessage({id: 'preferences.analysis.default.pool-scale-prevention-tooltip-ca'})}
      />
    );

    const spaScalePreventionLabels = ['None', 'Stain & Scale Control', 'Rapid-Dissolve Stain & Scale Tabs'];
    const spaScalePreventionKeys = [61, 133, 227];

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.default.spa-scale-prevention'})}
        dataKey="spaScalePrevention"
        key="spaScalePrevention"
        data-event-category="User"
        data-event-action="sel-ana-def-spa-sca-prev"
        value={dealer.spaScalePrevention}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={spaScalePreventionLabels}
        keys={spaScalePreventionKeys}
      />
    );

    const spapHAdjusterLabels = dealer.country === 'US' ? 
      ['pH Decreaser', 'Rapid-Dissolve pH Decreaser Tabs'] : 
      ["Lo 'N Slo", 'Rapid-Dissolve pH Decreaser Tabs'];
      
    const spapHAdjusterKeys = dealer.country === 'US' ? 
      [10, 226] :
      [169, 226];

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.default.spa-pH-adjuster'})}
        dataKey="spapHAdjuster"
        key="spapHAdjuster"
        data-event-category="User"
        data-event-action="sel-ana-def-spa-pH-decr"
        value={dealer.spapHAdjuster}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={spapHAdjusterLabels}
        keys={spapHAdjusterKeys}
      />
    );

    const spaTAAdjusterLabels = dealer.country === 'US' ? 
      ['Total Alkalinity Increaser', 'Rapid-Dissolve Alkalinity Increaser Tabs'] :
      ['Balance Pak 100', 'Rapid-Dissolve Alkalinity Increaser Tabs'];

    const spaTAAdjusterKeys = dealer.country === 'US' ? 
      [9, 230] :
      [170, 230];

    all.push(
      <LayoutSelect
        label={formatMessage({id: 'preferences.analysis.default.spa-TA-adjuster'})}
        dataKey="spaTAAdjuster"
        key="spaTAAdjuster"
        data-event-category="User"
        data-event-action="sel-ana-def-spa-TA-incr"
        value={dealer.spaTAAdjuster}
        editMode={props.edit}
        dataChanged={props.dataChanged}
        options={spaTAAdjusterLabels}
        keys={spaTAAdjusterKeys}
      />
    );

    return balanceColumns(all, 2);
  };

  render() {
    const {dealer, ncProductsIntegration} = this.props;
    let {formatMessage} = this.props.intl;
    let waterBalance = this.props.dealer ? this.getWaterBalance() : [];
    let productOptions = this.props.dealer ? this.getProductOptions() : [];
    let calculationParameters = this.props.dealer ? this.getCalculationParameters() : [];
    let nextAnalysis = this.props.dealer ? this.getNextAnalysis() : [];
    let analysisReport = this.props.dealer && session.getUser().privileges.level >= 2000 ? this.getAnalysisReport() : [];
    let seasonUsage = this.props.dealer ? this.getSeasonUsage() : [];
    let spaCleanDrainOptions = this.props.dealer ? this.spaCleanDrainOptions() : [];
    let defaultProductOptions = this.props.dealer ? this.getDefaultProducts() : [];

    return (
      <div>
        {/* [ALEX-2771] Disabling TB given that it will not be a promotion in 2020.  */}
        {/* <TruBluePreferences dealer={this.props.dealer}
                            edit={this.props.edit}
                            onChange={this.props.dataChanged}
                            products={this.props.products}/> */}

        <PrintOutOptions edit={this.props.edit} dealer={this.props.dealer} onChange={this.props.dataChanged} />

        <h2 className="with-keyline">
          <FormattedMessage id="preferences.analysis.water.balance" />
          <ToolTip title={formatMessage({id: 'preferences.analysis.balance.tooltip'})} position={tooltipPositions.topRight} iconOnly style={{float: 'right'}} />
        </h2>
        <div className="col-xs-12">{waterBalance}</div>

        {dealer.country === countries.CA ?
          <React.Fragment>
            <h2 className="with-keyline">
              <FormattedMessage id="preferences.analysis.temperature.settings" />
            </h2>
            <div className="col-xs-12">
              <div className="col-sm-4">
                <LayoutSelect
                  label={formatMessage({id: 'preferences.analysis.temperature.default'})}
                  dataKey="preferredTemperature"
                  key="preferredTemperature"
                  data-event-category="User"
                  data-event-action="select-ana-default-temperature"
                  value={dealer.preferredTemperature}
                  editMode={this.props.edit}
                  dataChanged={this.props.dataChanged}
                  keys={[temperatureFormat.CELSIUS, temperatureFormat.FARENHEIT]}
                  options={['°C', '°F']}
                />
              </div>
            </div>
          </React.Fragment> :
         null}

        <h2 className="with-keyline">
          <FormattedMessage id="preferences.analysis.product.options" />
        </h2>
        <div className="col-xs-12">{productOptions}</div>

        <h2 className="with-keyline">
          <FormattedMessage id="preferences.analysis.default.product" />
        </h2>
        <div className="col-xs-12">{defaultProductOptions}</div>

        {dealer.country === countries.US ?
          <React.Fragment>
            <h2 className="with-keyline">
              <FormattedMessage id="preferences.analysis.calculation.parameters" />
            </h2>
            <div className="col-xs-12">{calculationParameters}</div>
          </React.Fragment> :
         null}

        <h2 className="with-keyline">
          <FormattedMessage id="preferences.analysis.spa.draining" />
        </h2>
        <div className="col-xs-12">{spaCleanDrainOptions}</div>

        <h2 className="next-analysis with-keyline">
          <FormattedMessage id="preferences.analysis.analysis.settings" />
          <ToolTip
            title={formatMessage({id: 'preferences.analysis.analysis.tooltip'})}
            position={tooltipPositions.topRight}
            iconOnly
            style={{float: 'right'}}
          />
        </h2>
        <div className="col-xs-12">{nextAnalysis}</div>

        <h2 className="with-keyline">
          <FormattedMessage id="preferences.analysis.report.settings" />
        </h2>
        <div className="col-xs-12">{analysisReport}</div>

        <h2 className="season-usage with-keyline">
          <FormattedMessage id="preferences.analysis.season.usage" />
          <ToolTip title={formatMessage({id: 'preferences.analysis.season.tooltip'})} position={tooltipPositions.topRight} iconOnly style={{float: 'right'}} />
        </h2>
        <div className="col-xs-12">{seasonUsage}</div>
      </div>
    );
  }
}

export default injectIntl(PreferenceOptions);
